import { BrowseTabsLayout } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs";

export const unstable_settings = { anchor: "levels" };

export default function BrowseLayoutRoute() {
  return (
    <BrowseTabsLayout
      index="/(nav)/(app)/browse/(browse-tabs)"
      tabs={[
        {
          route: "/(nav)/(app)/browse/(browse-tabs)/levels",
          title: "Levels",
        },
        {
          route: "/(nav)/(app)/browse/(browse-tabs)/characters",
          title: "Characters",
        },
        {
          route: "/(nav)/(app)/browse/(browse-tabs)/primitives",
          title: "Primitives",
        },
        {
          route: "/(nav)/(app)/browse/(browse-tabs)/words",
          title: "Words",
        },
      ]}
    />
  );
}
